var customerPhone = $('#customer-phone');

var intlTel = customerPhone.intlTelInput({
  utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/8.4.6/js/utils.js"
});

customerPhone.change(function() {
  document.getElementById('customer-phone-with-country-code').value = "+" + customerPhone.intlTelInput('getSelectedCountryData').dialCode + customerPhone.val().replace(/[^\d]/g, '').replace(/^0+/, '')
  switch(customerPhone.intlTelInput('getValidationError')) {
    case 0:
      customerPhone[0].setCustomValidity('');
      break;
    case 1:
      customerPhone[0].setCustomValidity('El codigo de pais no existe')
      break;
    case 2:
      customerPhone[0].setCustomValidity('Es demasiado corto')
      break;
    case 3:
      customerPhone[0].setCustomValidity('Es demasiado largo')
      break;
    case 4:
      customerPhone[0].setCustomValidity('No parece un numero')
      break;
    default:
      customerPhone[0].setCustomValidity('')
      break;
  }

  if(customerPhone.intlTelInput('isValidNumber')) {
    var dialCode = "+"+customerPhone.intlTelInput('getSelectedCountryData').dialCode
    var number = customerPhone.intlTelInput('getNumber', intlTelInputUtils.numberFormat.E164)
    localStorage.setItem('customerPhone', JSON.stringify({
      phone: number.replace(dialCode, ""),
      countryIso: customerPhone.intlTelInput('getSelectedCountryData').iso2,
      countryCode: dialCode
    }));
  }
});

if(localStorage.customerPhone) {
  var customerPhoneValues = JSON.parse(localStorage.getItem('customerPhone'));
  customerPhone.val(customerPhoneValues.phone);
  customerPhone.intlTelInput('setCountry', customerPhoneValues.countryIso);
  document.getElementById('customer-phone-with-country-code').value = customerPhoneValues.countryCode + customerPhoneValues.phone
}